"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatearNumero = void 0;
const formatearNumero = (numero, cantDecimales) => {
    let numeroRedondeado = numero.toFixed(cantDecimales);
    numeroRedondeado = numeroRedondeado.replace(".", ",");
    // --- Agrego puntos ----
    // Separar la parte entera y la parte decimal
    let partes = numeroRedondeado.split(",");
    let parteEntera = partes[0];
    let parteDecimal = partes[1] || "";
    // Agregar puntos cada tres dígitos en la parte entera
    let numeroConPuntos = "";
    let contador = 0;
    for (let i = parteEntera.length - 1; i >= 0; i--) {
        contador++;
        numeroConPuntos = parteEntera[i] + numeroConPuntos;
        if (contador === 3 && i !== 0) {
            numeroConPuntos = "." + numeroConPuntos;
            contador = 0;
        }
    }
    // Comprobar si hay parte decimal y agregarla al resultado
    if (parteDecimal !== "") {
        numeroConPuntos += "," + parteDecimal;
    }
    let resultado = numeroConPuntos;
    return resultado;
};
exports.formatearNumero = formatearNumero;
